// Texty stránky Kontakt — slovenské dvojče locale/cs/contactPage.js.
import { NBSP } from '../../modules/money.js';

export default {
  h1: 'Sme tu pre vás',
  perex: 'Tím Jipos vybaví vašu objednávku, reklamáciu aj' + NBSP + 'otázku k' + NBSP + 'náradiu.',
  hoursNote: 'Na e-mail odpovedáme zvyčajne do pár hodín',
  faqTitle: 'Najčastejšie otázky vyriešite hneď',
  faqHint: 'Bez čakania, online',
  tipTitle: 'Odkazy k vašej objednávke',
  tipText:
    'Odkazy prepojené priamo s vašou objednávkou nájdete v e-maile s potvrdením objednávky, takže nemusíte zadávať žiadne údaje.',
  reach: 'Ozvite sa nám',
  storeFallback: 'Predajňa náradia Bílina',
  openNow: 'práve otvorené',
  navigate: 'Navigovať na predajňu',
  storeMore: 'Čo u nás nájdete',
  billing: 'Fakturačné údaje',
  team: 'Tím Jipos',
  teamHint: 'Na koho sa obrátiť priamo',
  gallery: 'Pozrite sa k nám na predajňu',
  video: 'Videoprehliadka',
  videoCap: 'Predajňa Jipos · Bílina',
  map: 'Kde nás nájdete',
  mapCta: 'Otvoriť v mapách',
  heroAlt: 'Tím Jipos pred predajňou v Bíline',
  crumbFallback: 'Kontakt',
  galleryAlt: 'Predajňa Jipos v Bíline',
  tiles: [
    { title: 'Stav objednávky', sub: 'Sledovať zásielku' },
    { title: 'Reklamácia', sub: 'Založiť online' },
    { title: 'Vrátenie tovaru', sub: 'Do 14 dní od prevzatia' },
  ],
  // Obsah administrácie SK /kontakty/ je dnes po znaku český (dev/sk/contact.html),
  // preto regexy berú českú aj slovenskú podobu.
  tileRe: [/stav|objedn/i, /reklam/i, /vr[áa]t|odst[oú]p|14/i, /caste-dotazy|caste-otazky|[čc]ast[ée] (dotazy|ot[áa]zky)|faq/i],
  cardShopRe: /e-?shop/i,
  cardStoreRe: /prodejn|predaj/i,
  cardBillingRe: /faktur|[úu]daj/i,
  idLabel: (label) => (label === 'IČ' ? 'IČO' : label),
};
